import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 5V4a2 2 0 0 1 2-2h8.5L20 7.5V20a2 2 0 0 1-2 2H4",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Rect, { width: "8", height: "5", x: "2", y: "13", rx: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 13v-2a2 2 0 1 0-4 0v2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileLock2";
const FileLock2 = memo(themed(Icon));
export {
  FileLock2
};
//# sourceMappingURL=file-lock-2.js.map
